import React, { useState } from 'react';
import { syncService } from '../../services/syncService';
import { useSyncStore } from '../../store/syncStore';

const SyncButton = () => {
  const [isStarting, setIsStarting] = useState(false);
  const [lastSyncMessage, setLastSyncMessage] = useState<string | null>(null);
  const { fetchSyncStatus, syncStatus } = useSyncStore();

  const handleStartSync = async () => {
    setIsStarting(true);
    setLastSyncMessage(null);

    try {
      const response = await syncService.startSync();
      
      // Проверяем, есть ли поле 'data' (успешный ответ) или только 'message' (ошибка)
      if ('data' in response) {
        // Успех - синхронизация запущена
        setLastSyncMessage(`✅ ${response.data.message}`);
        
        // Обновляем статус через несколько секунд
        setTimeout(() => {
          fetchSyncStatus();
        }, 2000);
      } else {
        // Ошибка - синхронизация уже запущена
        setLastSyncMessage(`⚠️ ${response.message}`);
      }
    } catch (error: any) {
      // Обрабатываем ошибку 409 (Conflict) - синхронизация уже запущена
      if (error.response?.status === 409) {
        const errorData = error.response.data;
        if (errorData && errorData.message) {
          setLastSyncMessage(`⚠️ ${errorData.message}`);
        } else {
          setLastSyncMessage(`⚠️ Синхронизация уже выполняется`);
        }
      } else {
        const errorMessage = error instanceof Error ? error.message : 'Неизвестная ошибка';
        setLastSyncMessage(`❌ Ошибка: ${errorMessage}`);
      }
    } finally {
      setIsStarting(false);
    }
  };

  return (
    <div className="bg-white rounded-lg shadow-md p-6">
      <div className="text-center">
        <h3 className="text-xl font-semibold text-gray-800 mb-4">
          🔄 Ручная синхронизация
        </h3>
        
        <button
          onClick={handleStartSync}
          disabled={isStarting || syncStatus?.is_running}
          className={`px-8 py-4 rounded-lg font-medium text-white transition-colors flex items-center gap-2 mx-auto ${
            isStarting || syncStatus?.is_running
              ? 'bg-gray-400 cursor-not-allowed'
              : 'bg-blue-500 hover:bg-blue-600'
          }`}
        >
          {isStarting ? (
            <>
              <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div>
              Запуск синхронизации...
            </>
          ) : syncStatus?.is_running ? (
            <>
              <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div>
              Синхронизация выполняется...
            </>
          ) : (
            <>
              <span>🚀</span>
              Синхронизировать
            </>
          )}
        </button>

        {lastSyncMessage && (
          <div className={`mt-4 p-3 rounded-lg text-sm ${
            lastSyncMessage.includes('✅') 
              ? 'bg-green-50 text-green-800 border border-green-200'
              : lastSyncMessage.includes('⚠️')
              ? 'bg-yellow-50 text-yellow-800 border border-yellow-200'
              : 'bg-red-50 text-red-800 border border-red-200'
          }`}>
            {lastSyncMessage}
          </div>
        )}

        <div className="mt-4 text-sm text-gray-600">
          <p>Синхронизация может занять 5-15 минут</p>
          <p>Результаты будут доступны после завершения</p>
        </div>
      </div>
    </div>
  );
};

export default SyncButton;
